import React, { Fragment } from "react";

import { ACCEPTED_DOCS_TYPES } from "../../config";
import { MediaInput as FobMediaInput } from "ra-friendsofbabba";
import { useTranslate } from "react-admin";

const MediaInput = ({
  disabled,
  acceptedFormats = ACCEPTED_DOCS_TYPES,
  ...props
}) => {
  const translate = useTranslate();
  return (
    <Fragment>
      <FobMediaInput
        {...props}
        disabled={disabled}
        multiple
        title="file.name"
        accept={acceptedFormats.join(",")}
        helperText={translate(`ra.media.help`, {
          acceptedFormats,
        })}
      />
    </Fragment>
  );
};
export default MediaInput;
